"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _ShopConnectionActions = require("../actions/ShopConnectionActions");

var _handleActions;

var initialState = new _immutable.Map({
  shopifyConnectModalIsOpen: false,
  shopifyUrlPopoverIsOpen: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _ShopConnectionActions.ShopConnectionActionTypes.OPEN_MODAL, function (state) {
  return state.set('shopifyConnectModalIsOpen', true);
}), (0, _defineProperty2.default)(_handleActions, _ShopConnectionActions.ShopConnectionActionTypes.CLOSE_MODAL, function () {
  return initialState;
}), (0, _defineProperty2.default)(_handleActions, _ShopConnectionActions.ShopConnectionActionTypes.TOGGLE_SHOPIFY_URL_POPOVER, function (state) {
  return state.set('shopifyUrlPopoverIsOpen', !state.get('shopifyUrlPopoverIsOpen'));
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;